import { render, staticRenderFns } from "./ScaledImage.vue?vue&type=template&id=55fbceaf"
import script from "./ScaledImage.vue?vue&type=script&lang=ts"
export * from "./ScaledImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports